function podeEditarMixin (obj) {
	const user = this.$auth.user()

	if (user.perfil > 1) {
		if (user.perfil === 2) {
			return user.curadoriaId === obj.curadoriaId
		} else if (user.perfil === 3) {
			return user.curadoriaMae === obj.curadoriaId
		}
	}	else return true
}

export default {
	methods: {
		podeEditar: podeEditarMixin
	}
}
